/* Handyhülle selbst gestalten: Foto wählen, prüfen, platzieren, druckfertig übergeben. Stand 10.10.2026
   Sicherheit:
   - Nur echte Bilddateien (Dateianfang wird geprüft, nicht die Endung), max. 25 MB, kein SVG/PDF.
   - Das Foto wird im Browser NEU als JPG gezeichnet. In den Warenkorb geht nur dieses frische Bild:
     keine versteckten Inhalte, keine Metadaten (GPS, Kamera), fester Dateiname.
   - Nutzertexte landen nie als HTML im DOM (nur textContent).
   Ablauf beim "In den Warenkorb": Klick wird abgefangen (window, capture = vor Theme + Ketten-Bundle),
   Foto + Vorschau werden erzeugt und in die Datei-Felder gelegt, dann wird das Formular erneut abgeschickt. */
(function () {
  'use strict';
  var root = document.querySelector('[data-sk-foto]');
  if (!root) return;

  var MAX_MB = 25;
  var MIN_KANTE = 400;          // kürzere Seite in Pixeln, darunter abgelehnt
  var ARBEIT_MAX = 3000;        // Arbeitskopie (Speicher schonen)
  var AUSGABE_MAX = 3000;       // längste Seite der Druckdatei
  var HUELLE_CM = 7.5;          // ungefähre Breite der Rückseite für die DPI-Schätzung
  var DPI_WARN = 170, DPI_STOP = 75;

  var messen = function (a, w) { try { if (window.skMessen) window.skMessen(a, w); } catch (e) {} };
  var $ = function (s) { return root.querySelector(s); };
  var canvas = $('[data-sk-foto-canvas]');
  var ctx = canvas.getContext('2d');
  var leer = $('[data-sk-foto-leer]');
  var werkzeuge = $('[data-sk-foto-werkzeuge]');
  var zoomEl = $('[data-sk-foto-zoom]');
  var fehlerEl = $('[data-sk-foto-fehler]');
  var qualEl = $('[data-sk-foto-qualitaet]');
  var hinweisEl = $('[data-sk-foto-hinweis]');
  var picker = $('[data-sk-foto-input]');
  var dateiFeld = $('[data-sk-foto-datei]');
  var vorschauFeld = $('[data-sk-foto-vorschau]');
  var rechte = $('[data-sk-foto-rechte]');
  var farbe = $('[data-sk-foto-farbe]');

  var daten = {}, varianten = {};
  try { daten = JSON.parse(root.querySelector('[data-sk-foto-daten]').textContent); } catch (e) {}
  try { varianten = JSON.parse(root.querySelector('[data-sk-foto-varianten]').textContent); } catch (e) {}

  /* Formular des Warenkorb-Knopfs (nicht das Raten-Formular) und alle Felder daran hängen */
  var addBtn = document.querySelector('product-form [name="add"], form[action*="/cart/add"] [name="add"]');
  var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
  /* Felder DIREKT ins Warenkorb-Formular legen. NICHT über das form-Attribut: im Theme tragen zwei Formulare
     dieselbe id (auch das Raten-Formular) -> form="id" würde am falschen Formular hängen (Test 10.10.2026). */
  var rechteFeld = null, farbFeld = null;
  if (form) {
    var fach = document.createElement('div');
    fach.hidden = true; fach.setAttribute('data-sk-foto-fach', '');
    [dateiFeld, vorschauFeld, root.querySelector('[name="properties[_sk_quelle]"]')].forEach(function (el) {
      if (el) { el.removeAttribute('form'); fach.appendChild(el); }
    });
    rechteFeld = document.createElement('input');
    rechteFeld.type = 'hidden'; rechteFeld.name = 'properties[Bildrechte]'; rechteFeld.value = 'bestätigt'; rechteFeld.disabled = true;
    fach.appendChild(rechteFeld);
    farbFeld = document.createElement('input');
    farbFeld.type = 'hidden'; farbFeld.name = 'properties[Farbhinweis]'; farbFeld.value = 'bestätigt'; farbFeld.disabled = true;
    fach.appendChild(farbFeld);
    form.appendChild(fach);
    if (farbe) farbe.addEventListener('change', function () { farbFeld.disabled = !farbe.checked; if (farbe.checked) fehler(''); });
    if (rechte) {
      rechte.removeAttribute('name');
      rechte.addEventListener('change', function () { rechteFeld.disabled = !rechte.checked; if (rechte.checked) fehler(''); });
    }
  }

  var zeige = function (el, text) { if (!el) return; el.textContent = text || ''; el.hidden = !text; };
  var fehler = function (text, art) { zeige(fehlerEl, text); if (text) messen('foto_fehler', art || ''); };

  /* ---------- Zustand ---------- */
  var vorlage = null;            // {bild:Image, maske:Image, bbox:[x,y,w,h], w, h, key}
  var quelle = null;             // Canvas mit der bereinigten Arbeitskopie
  var t = { s: 1, x: 0, y: 0, rot: 0, zoom: 1 };   // s = Canvas-Pixel je Quellpixel, x/y = Bildmitte
  var bereit = false;            // true = Dateien liegen im Formular, nächster Submit darf durch

  /* ---------- Modell -> Vorlage ---------- */
  var cache = {};
  function ladeBild(src) {
    return new Promise(function (ok, nein) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { ok(im); }; im.onerror = nein; im.src = src;
    });
  }
  function aktuelleVariante() {
    var idEl = form && form.querySelector('[name="id"]');
    return idEl ? String(idEl.value) : '';
  }
  function setzeModell() {
    var label = varianten[aktuelleVariante()];
    var m = label && daten.modelle && daten.modelle[label];
    if (!m) return;
    var v = daten.vorlagen[m.v];
    zeige(hinweisEl, m.aehnlich ? 'Die Vorschau zeigt eine ähnliche Hülle. Deine Hülle hat den passenden Kameraausschnitt für das ' + label + '.' : '');
    if (vorlage && vorlage.key === m.v) return;
    var p = cache[m.v] || (cache[m.v] = Promise.all([ladeBild(v.bild), ladeBild(v.maske)]));
    p.then(function (r) {
      var alt = vorlage;
      vorlage = { bild: r[0], maske: r[1], bbox: v.bbox, w: v.w, h: v.h, key: m.v };
      canvas.width = v.w; canvas.height = v.h;
      if (quelle) { if (alt) passeAn(alt); else einpassen(); }
      zeichne();
    }).catch(function () { fehler('Die Vorschau konnte nicht geladen werden. Lade die Seite bitte neu.', 'vorlage'); });
    bereit = false;
  }
  if (window.eventBus) {
    window.eventBus.on('variant:updated', function () { setTimeout(setzeModell, 0); });
    window.eventBus.on('variant:change', function () { setTimeout(setzeModell, 0); });
  }
  document.addEventListener('change', function () { setTimeout(setzeModell, 0); });

  /* ---------- Geometrie ---------- */
  function dims() {   // Bildmaße nach Drehung (nur für 0/90/180/270 exakt, sonst Hülle über Skala abgedeckt)
    var q = Math.round(t.rot / 90) % 2 === 0;
    return { w: q ? quelle.width : quelle.height, h: q ? quelle.height : quelle.width };
  }
  function deckSkala() {
    var b = vorlage.bbox, d = dims();
    return Math.max(b[2] / d.w, b[3] / d.h);
  }
  function rechtwinklig() { return Math.abs(t.rot - Math.round(t.rot / 90) * 90) < 0.01; }
  function mindestSkala() {   // kleinste Skala, bei der alle Ecken der Hülle im (gedrehten) Foto liegen
    var b = vorlage.bbox, a = -t.rot * Math.PI / 180, c = Math.cos(a), sn = Math.sin(a), m = 0;
    [[b[0], b[1]], [b[0] + b[2], b[1]], [b[0], b[1] + b[3]], [b[0] + b[2], b[1] + b[3]]].forEach(function (p) {
      var dx = p[0] - t.x, dy = p[1] - t.y;
      var u = dx * c - dy * sn, v = dx * sn + dy * c;
      m = Math.max(m, 2 * Math.abs(u) / quelle.width, 2 * Math.abs(v) / quelle.height);
    });
    return m;
  }
  function begrenze() {   // Foto muss die Hülle immer ganz bedecken
    var b = vorlage.bbox;
    t.s = deckSkala() * t.zoom;
    if (rechtwinklig()) {
      var d = dims(), hw = d.w * t.s / 2, hh = d.h * t.s / 2;
      t.x = Math.min(b[0] + hw, Math.max(b[0] + b[2] - hw, t.x));
      t.y = Math.min(b[1] + hh, Math.max(b[1] + b[3] - hh, t.y));
    } else {
      // schräg: Mitte nahe der Hülle halten, fehlende Abdeckung durch etwas Vergrößern ausgleichen
      t.x = Math.min(b[0] + b[2], Math.max(b[0], t.x));
      t.y = Math.min(b[1] + b[3], Math.max(b[1], t.y));
      t.s = Math.max(t.s, mindestSkala() * 1.002);
    }
  }
  function einpassen() {
    var b = vorlage.bbox;
    t.zoom = 1; t.x = b[0] + b[2] / 2; t.y = b[1] + b[3] / 2;
    if (zoomEl) zoomEl.value = '1';
    begrenze();
  }
  function passeAn(alt) {   // Modellwechsel: relative Lage zur Hülle behalten
    var a = alt.bbox, b = vorlage.bbox;
    t.x = b[0] + (t.x - a[0]) / a[2] * b[2];
    t.y = b[1] + (t.y - a[1]) / a[3] * b[3];
    begrenze();
  }
  function maleFoto(c) {
    c.save();
    c.translate(t.x, t.y); c.rotate(t.rot * Math.PI / 180); c.scale(t.s, t.s);
    c.drawImage(quelle, -quelle.width / 2, -quelle.height / 2);
    c.restore();
  }

  /* ---------- Zeichnen ---------- */
  var ebene = document.createElement('canvas'), ectx = ebene.getContext('2d');
  function zeichne() {
    if (!vorlage) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(vorlage.bild, 0, 0, canvas.width, canvas.height);
    if (quelle) {
      ebene.width = canvas.width; ebene.height = canvas.height;
      ectx.clearRect(0, 0, ebene.width, ebene.height);
      maleFoto(ectx);
      ectx.globalCompositeOperation = 'destination-in';
      ectx.drawImage(vorlage.maske, 0, 0, ebene.width, ebene.height);
      ectx.globalCompositeOperation = 'source-over';
      ctx.drawImage(ebene, 0, 0);
      ctx.globalCompositeOperation = 'multiply';   // Licht und Schatten der echten Hülle
      ctx.drawImage(vorlage.bild, 0, 0, canvas.width, canvas.height);
      ctx.globalCompositeOperation = 'source-over';
      pruefeQualitaet();
    }
  }
  function dpi() {
    if (!quelle || !vorlage) return 0;
    return (vorlage.bbox[2] / t.s) / (HUELLE_CM / 2.54);
  }
  function pruefeQualitaet() {
    var d = dpi();
    if (d < DPI_STOP) zeige(qualEl, 'Dieses Foto ist zu klein für einen scharfen Druck. Wähle bitte ein größeres Foto oder zoome weniger.');
    else if (d < DPI_WARN) zeige(qualEl, 'Das Foto ist etwas klein. Wir drucken es, es kann aber leicht weich wirken.');
    else zeige(qualEl, '');
    if (qualEl) qualEl.classList.toggle('is-stop', d < DPI_STOP);
  }

  /* ---------- Datei prüfen und bereinigen ---------- */
  function typAusKopf(b) {
    var h = function (i) { return b[i]; };
    if (h(0) === 0xFF && h(1) === 0xD8 && h(2) === 0xFF) return 'jpg';
    if (h(0) === 0x89 && h(1) === 0x50 && h(2) === 0x4E && h(3) === 0x47) return 'png';
    if (h(0) === 0x52 && h(1) === 0x49 && h(2) === 0x46 && h(3) === 0x46 && h(8) === 0x57 && h(9) === 0x45 && h(10) === 0x42 && h(11) === 0x50) return 'webp';
    var ftyp = String.fromCharCode(h(4), h(5), h(6), h(7)), marke = String.fromCharCode(h(8), h(9), h(10), h(11));
    if (ftyp === 'ftyp' && /^(heic|heix|hevc|heim|heis|mif1|msf1|avif)$/.test(marke)) return 'heic';
    return '';
  }
  function nimmDatei(file) {
    fehler(''); bereit = false;
    if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) return fehler('Die Datei ist größer als ' + MAX_MB + ' MB. Wähle bitte ein kleineres Foto.', 'gross');
    file.slice(0, 16).arrayBuffer().then(function (buf) {
      var typ = typAusKopf(new Uint8Array(buf));
      if (!typ) return fehler('Das ist keine Bilddatei. Erlaubt sind Fotos als JPG, PNG, WebP oder HEIC.', 'typ');
      var url = URL.createObjectURL(file);
      var im = new Image();
      var weg = function () { URL.revokeObjectURL(url); };
      im.onload = function () {
        weg();
        var w = im.naturalWidth, h = im.naturalHeight;
        if (Math.min(w, h) < MIN_KANTE) return fehler('Das Foto ist zu klein (' + w + ' × ' + h + ' Pixel). Nimm bitte ein Foto mit mindestens ' + MIN_KANTE + ' Pixeln an der kurzen Seite.', 'klein');
        var f = Math.min(1, ARBEIT_MAX / Math.max(w, h));
        var c = document.createElement('canvas');
        c.width = Math.round(w * f); c.height = Math.round(h * f);
        var cx = c.getContext('2d');
        cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);   // transparente PNGs: weißer Grund wie die Hülle
        cx.drawImage(im, 0, 0, c.width, c.height);
        quelle = c; t.rot = 0;
        root.classList.add('has-foto');
        if (leer) leer.hidden = true;
        if (werkzeuge) werkzeuge.hidden = false;
        if (vorlage) { einpassen(); zeichne(); }
        messen('foto_gewaehlt', typ);
      };
      im.onerror = function () {
        weg();
        fehler(typ === 'heic' ? 'Dein Browser kann dieses HEIC-Foto nicht öffnen. Wähle es bitte als JPG aus (am iPhone: Teilen > Als JPEG sichern) oder nutze Safari.' : 'Das Foto lässt sich nicht öffnen. Versuche bitte ein anderes.', 'oeffnen');
      };
      im.src = url;
    }).catch(function () { fehler('Das Foto lässt sich nicht lesen. Versuche bitte ein anderes.', 'lesen'); });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-sk-foto-waehlen], [data-sk-foto-neu]')) { picker.value = ''; picker.click(); return; }
    if (!quelle || !vorlage) return;
    if (e.target.closest('[data-sk-foto-drehen]')) { t.rot = (Math.round(t.rot / 90) * 90 + 90) % 360; einpassen(); zeichne(); bereit = false; messen('foto_gedreht', String(t.rot)); }
    if (e.target.closest('[data-sk-foto-zurueck]')) { einpassen(); zeichne(); bereit = false; }
  });
  picker.addEventListener('change', function () { nimmDatei(picker.files && picker.files[0]); });
  /* Ziehen & Ablegen (Desktop) */
  ['dragenter', 'dragover'].forEach(function (ev) { root.addEventListener(ev, function (e) { e.preventDefault(); root.classList.add('is-drag'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { root.addEventListener(ev, function (e) { e.preventDefault(); root.classList.remove('is-drag'); }); });
  root.addEventListener('drop', function (e) { var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; nimmDatei(f); });

  if (zoomEl) zoomEl.addEventListener('input', function () {
    if (!quelle || !vorlage) return;
    t.zoom = parseFloat(zoomEl.value) || 1; begrenze(); zeichne(); bereit = false;
  });

  /* ---------- Verschieben / Zoomen (Finger, Maus, Tastatur) ---------- */
  var zeiger = {}, start = null;
  function punkt(e) {
    var r = canvas.getBoundingClientRect();
    return { x: (e.clientX - r.left) * canvas.width / r.width, y: (e.clientY - r.top) * canvas.height / r.height };
  }
  function lage() {
    var ids = Object.keys(zeiger);
    if (ids.length === 1) return { m: zeiger[ids[0]], d: 0 };
    var a = zeiger[ids[0]], b = zeiger[ids[1]];
    return { m: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, d: Math.hypot(a.x - b.x, a.y - b.y),
             w: Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI };
  }
  canvas.addEventListener('pointerdown', function (e) {
    if (!quelle || !vorlage) return;
    canvas.setPointerCapture(e.pointerId);
    zeiger[e.pointerId] = punkt(e);
    start = { l: lage(), x: t.x, y: t.y, zoom: t.zoom, rot: t.rot };
  });
  canvas.addEventListener('pointermove', function (e) {
    if (!(e.pointerId in zeiger) || !start) return;
    zeiger[e.pointerId] = punkt(e);
    var l = lage();
    if (l.d && start.l.d) {
      t.zoom = Math.min(4, Math.max(1, start.zoom * l.d / start.l.d));
      if (zoomEl) zoomEl.value = String(t.zoom);
      var r = start.rot + (l.w - start.l.w);
      r = ((r % 360) + 360) % 360;
      var naechst = Math.round(r / 90) * 90;
      t.rot = Math.abs(r - naechst) < 5 ? naechst % 360 : r;   // gerade Lage rastet ein
    }
    t.x = start.x + (l.m.x - start.l.m.x);
    t.y = start.y + (l.m.y - start.l.m.y);
    begrenze(); zeichne(); bereit = false;
  });
  var los = function (e) {
    delete zeiger[e.pointerId];
    start = Object.keys(zeiger).length ? { l: lage(), x: t.x, y: t.y, zoom: t.zoom, rot: t.rot } : null;
  };
  canvas.addEventListener('pointerup', los);
  canvas.addEventListener('pointercancel', los);
  canvas.addEventListener('wheel', function (e) {
    if (!quelle || !vorlage) return;
    e.preventDefault();
    t.zoom = Math.min(4, Math.max(1, t.zoom * (e.deltaY < 0 ? 1.06 : 1 / 1.06)));
    if (zoomEl) zoomEl.value = String(t.zoom);
    begrenze(); zeichne(); bereit = false;
  }, { passive: false });
  canvas.addEventListener('keydown', function (e) {
    if (!quelle || !vorlage) return;
    var s = 12, k = e.key;
    if (k === 'ArrowLeft') t.x -= s; else if (k === 'ArrowRight') t.x += s;
    else if (k === 'ArrowUp') t.y -= s; else if (k === 'ArrowDown') t.y += s;
    else if (k === '+' || k === '=') t.zoom = Math.min(4, t.zoom * 1.06);
    else if (k === '-') t.zoom = Math.max(1, t.zoom / 1.06);
    else if (k === '[' || k === ']') { t.rot = (((t.rot + (k === ']' ? 5 : -5)) % 360) + 360) % 360; }
    else return;
    e.preventDefault(); if (zoomEl) zoomEl.value = String(t.zoom);
    begrenze(); zeichne(); bereit = false;
  });

  /* ---------- Druckdatei + Vorschau erzeugen ---------- */
  function alsDatei(c, name, q) {
    return new Promise(function (ok, nein) {
      c.toBlob(function (b) { b ? ok(new File([b], name, { type: 'image/jpeg' })) : nein(new Error('leer')); }, 'image/jpeg', q);
    });
  }
  function druckdatei() {
    var b = vorlage.bbox, rand = 0.04;
    var rx = b[0] - b[2] * rand, ry = b[1] - b[3] * rand, rw = b[2] * (1 + 2 * rand), rh = b[3] * (1 + 2 * rand);
    var k = Math.min(AUSGABE_MAX / Math.max(rw, rh), Math.max(1.5, 1 / t.s));   // nie stärker hochrechnen als nötig
    var c = document.createElement('canvas');
    c.width = Math.round(rw * k); c.height = Math.round(rh * k);
    var cx = c.getContext('2d');
    cx.fillStyle = '#fff'; cx.fillRect(0, 0, c.width, c.height);
    cx.setTransform(k, 0, 0, k, -rx * k, -ry * k);
    maleFoto(cx);
    return alsDatei(c, 'foto.jpg', 0.92);
  }
  function lege(feld, datei) {
    if (!feld || !datei) return;
    var dt = new DataTransfer(); dt.items.add(datei); feld.files = dt.files;
  }

  window.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    if (bereit) { bereit = false; return; }               // zweiter Durchlauf: Theme/Bundle übernehmen
    e.preventDefault(); e.stopImmediatePropagation();
    if (!quelle) { fehler('Wähle bitte zuerst dein Foto aus.', 'kein_foto'); root.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    if (dpi() < DPI_STOP) { fehler('Das Foto ist zu klein für einen scharfen Druck.', 'zu_klein'); return; }
    if (!rechte || !rechte.checked || !rechteFeld) { fehler('Bestätige bitte die Bildrechte (Häkchen unter der Vorschau).', 'rechte'); rechte && rechte.focus(); return; }
    if (!farbe || !farbe.checked || !farbFeld) { fehler('Bestätige bitte den Hinweis zu den Farben (zweites Häkchen).', 'farbe'); farbe && farbe.focus(); return; }
    fehler('');
    if (addBtn) addBtn.setAttribute('aria-busy', 'true');
    druckdatei().then(function (f) {
      lege(dateiFeld, f);
      return alsDatei(canvas, 'vorschau.jpg', 0.85).then(function (v) { lege(vorschauFeld, v); }).catch(function () {});
    }).then(function () {
      bereit = true;
      messen('foto_warenkorb', String(Math.round(dpi())));
      if (form.requestSubmit) form.requestSubmit(addBtn || undefined);
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }).catch(function () {
      fehler('Das Foto konnte nicht vorbereitet werden. Versuche es bitte noch einmal.', 'export');
    }).finally(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
  }, true);

  setzeModell();
})();
